import { render, staticRenderFns } from "./SlideBarSetting.vue?vue&type=template&id=2c760a2c"
import script from "./SlideBarSetting.vue?vue&type=script&lang=js"
export * from "./SlideBarSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports